export default "__VITE_ASSET___qxyXmBv__"